import { render, staticRenderFns } from "./CoinsInfoCard.vue?vue&type=template&id=ea7f4680&scoped=true&"
import script from "./CoinsInfoCard.vue?vue&type=script&lang=js&"
export * from "./CoinsInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CoinsInfoCard.vue?vue&type=style&index=0&id=ea7f4680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7f4680",
  null
  
)

export default component.exports